import {
    useMemo,
} from 'react'
import {
    createRoutesConfig,
    SkyNetRoutesConfig,
    useSkyNetNavigate,
} from 'app/SkyNetRoutes/index'
import {
    App,
    TransportPlannerDomains,
} from 'app/enums/domain.enums'

export default function useTransportPlannerRoutes() {
    const skyNetNavigate = useSkyNetNavigate()

    return useMemo(() => {
        const config: SkyNetRoutesConfig = {
            path: [App.TransportPlanner],
            Simulation: {
                route: TransportPlannerDomains.Simulation,
                params: [{
                    name: 'id',
                    required: true,
                }],
            },
            NewSimulation: {
                route: TransportPlannerDomains.Simulation,
            },
            CO2Calculation: {
                route: TransportPlannerDomains.C02Calculation,
            },
            SavedSimulations: {
                route: TransportPlannerDomains.SavedSimulations,
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [skyNetNavigate])
}
